// Package imports:
import React from 'react';
// Component imports:
import Entrypoint from '../Entrypoint';
import ViewForeignCompanyReport from '../../components/PEP/ViewForeignCompanyReport';
interface IViewReport {
    id: string
}
const ViewForeignCompanyReportPage: React.FC<IViewReport> = ({
    id
}) => {
    return (
        <Entrypoint>
            <ViewForeignCompanyReport id={id} />
        </Entrypoint>
    );
}

export default ViewForeignCompanyReportPage;